import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const UserPanel = () => {
  const admin = useSelector((state) => state.admin.admin);
  const { t } = useTranslation();
  const getInitials = (name) => {
    if (!name) return "";
    const names = name.trim().split(" ");
    if (names.length > 1) {
      return `${names[0][0]}${names[1][0]}`?.toUpperCase();
    }
    return names[0][0]?.toUpperCase();
  };

  const initials = getInitials(
    `${admin.first_name || ""} ${admin.last_name || ""}`,
  );

  return (
    <div>
      <div className="sidebar-user text-center">
        <div className="d-flex justify-content-center align-items-center">
          {admin.image ? (
            <img
              className="img-60 rounded-circle lazyloaded blur-up"
              src={admin.image}
              alt="#"
            />
          ) : (
            <div
              className="d-flex justify-content-center align-items-center rounded-circle"
              style={{
                backgroundColor: "#FF8084",
                color: "#fff",
                fontSize: "24px",
                fontWeight: "bold",
                width: "60px",
                height: "60px",
              }}
            >
              {initials}
            </div>
          )}
        </div>
        <h6 className="mt-3 f-14">
          {admin.first_name} {admin.last_name}
        </h6>
        <p>
          {/* {admin.role === "Staff" ? "WEGE Team Member" : "WEGE Administrator"} */}
          {admin.role === "Staff"
            ? t("WEGE_Team_Member")
            : t("WEGE_Administrator")}
        </p>
      </div>
    </div>
  );
};

export default UserPanel;
